export default "__VITE_ASSET__TRJ15sRq__"